<template>
  <div class="hello">
    <neon-effect :options="option"></neon-effect>
    <div id="hello">{{ greeting }}</div>
  </div>
</template>

<script>
import neonEffect from '../../src/components/neon'
export default {
  name: 'HelloWorld',
  data () {
    return {
      greeting: 'embrace the dystopia',
      option: {
        rate: 22
      }

    }
  },
  props: {},
  computed: {},
  components: {
    neonEffect
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
    font-family: 'Vulf Mono Regular';
    src:    url('/assets/fonts/Vulf_Mono-Regular_web.eot');
    src:    url('/assets/fonts/Vulf_Mono-Regular_web.eot?#iefix') format('embedded-opentype'),
            url('/assets/fonts/Vulf_Mono-Regular_web.woff') format('woff'),
            url('/assets/fonts/Vulf_Mono-Regular_web.woff2') format('woff2'),
            url('/assets/fonts/Vulf_Mono-Regular_web.ttf') format('truetype'),
            url('/assets/fonts/Vulf_Mono-Regular_web.svg#svgFontName') format('svg');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'Vulf Mono Black';
    src:    url('/assets/fonts/Vulf_Mono-Black_web.eot');
    src:    url('/assets/fonts/Vulf_Mono-Black_web.eot?#iefix') format('embedded-opentype'),
            url('/assets/fonts/Vulf_Mono-Black_web.woff') format('woff'),
            url('/assets/fonts/Vulf_Mono-Black_web.woff2') format('woff2'),
            url('/assets/fonts/Vulf_Mono-Black_web.ttf') format('truetype'),
            url('/assets/fonts/Vulf_Mono-Black_web.svg#svgFontName') format('svg');
    font-weight: 900;
    font-style: normal;
}

div#hello {
  font-weight: bold;
  font-family: 'Vulf Mono Regular';
  color:#016066;
  z-index: 1337;
  position: absolute;
  left:0;
  top:calc(50vh - 1em);
  font-size:3em;
  text-align: center;
  display: inline-block;
  width: 100vw;
  margin:0;
  padding: 0;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue